export default __webpack_public_path__ + "static/media/Bolts of Black Sorrow.69cae827.jpg";